import { useUpsertPolicyNote } from "@/hooks/useUpsertPolicyNote";
import { InlineNoteCell } from "./InlineNoteCell";

interface PolicyNoteCellProps {
  /** Policy the note is scoped to. */
  policyId?: string;
  /** Current note (PolicyRead.note, overlaid from policy_notes). */
  note?: string;
  /** Whether the user may edit (policies:edit + not read-only partner). */
  canEdit: boolean;
  /** block = full-width section (Claims Summary header); default = compact cell. */
  block?: boolean;
}

/**
 * Editable section for the policy-period summary Note (US 5370 / ADR-052 §10),
 * shown in the Claims Summary header. Writes via the dedicated upsert endpoint
 * (policy_notes) — never a synced store. Sibling to ClaimantPolicyNoteCell.
 */
export const PolicyNoteCell = ({ policyId, note, canEdit, block }: PolicyNoteCellProps) => {
  const { saveNote } = useUpsertPolicyNote();
  // Editing requires a policy to scope the note to — without it the endpoint
  // path would be malformed (e.g. policies//note).
  const editable = canEdit && !!policyId;
  return (
    <InlineNoteCell
      note={note}
      canEdit={editable}
      block={block}
      onSave={(value) => saveNote(policyId as string, value)}
    />
  );
};
